'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  border-radius: 20px;\n  transition: all 0.25s ease-out;\n  width: 56px;\n  height: 26px;\n  cursor: pointer;\n  padding: 3px 0 3px ', ';\n  background-color: transparent;\n  border: 2px solid ', ';\n\n  ', ';\n\n  ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  border-radius: 20px;\n  transition: all 0.25s ease-out;\n  width: 56px;\n  height: 26px;\n  cursor: pointer;\n  padding: 3px 0 3px ', ';\n  background-color: transparent;\n  border: 2px solid ', ';\n\n  ', ';\n\n  ', ';\n\n  ', ';\n\n  ', ';\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: ', ';\n    '], ['\n      background-color: ', ';\n    ']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  background-color: ', ';\n'], ['\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  background-color: ', ';\n']);

exports.default = ToggleButton;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

var _layout = require('../layout');

var _fieldLabel = require('../field-label');

var _fieldLabel2 = _interopRequireDefault(_fieldLabel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ToggleButton
 *
 * A standard toggle button for toggling between two states
 */

var StyledToggleButton = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject, function (props) {
  return props.selected ? '32px' : '3px';
}, function (props) {
  return props.theme.colors.grey300;
}, function (props) {
  return props.toggleButtonTheme === 'default' && props.selected && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.theme.colors.blue500);
}, function (props) {
  return props.toggleButtonTheme === 'green' && props.selected && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.theme.colors.green500);
}, function (props) {
  return props.toggleButtonTheme === 'orangeToGreen' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.selected ? props.theme.colors.green500 : props.theme.colors.orange500);
}, function (props) {
  return props.toggleButtonTheme === 'orange' && props.selected && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.theme.colors.orange500);
});

var StyledButton = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject3, function (props) {
  return props.toggleButtonTheme === 'orangeToGreen' ? props.theme.colors.white : props.selected ? props.theme.colors.white : props.theme.colors.grey500;
});

function ToggleButton(props) {
  var _props$value = props.value,
      value = _props$value === undefined ? false : _props$value,
      _props$theme = props.theme,
      theme = _props$theme === undefined ? 'default' : _props$theme,
      onChange = props.onChange,
      label = props.label,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['value', 'theme', 'onChange', 'label']);


  return React.createElement(
    _layout.Box,
    (0, _extends3.default)({
      flexDirection: 'row',
      alignItems: 'center',
      id: 'toggle-button',
      onClick: function onClick() {
        return onChange(!value);
      }
    }, otherProps),
    React.createElement(
      StyledToggleButton,
      { selected: value, toggleButtonTheme: theme },
      React.createElement(StyledButton, { toggleButtonTheme: theme, selected: value })
    ),
    label ? React.createElement(
      _fieldLabel2.default,
      { marginLeft: 'medium', marginBottom: 0 },
      label
    ) : null
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/toggle-button/toggle-button.js
// module id = 360
// module chunks = 114276838955818